module.exports = __webpack_public_path__ + "img/next-arrow-white.5304c384.svg";